import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

/**
 * Component that renders a green circle with Pipedrive logo inside and tooltip to explain.
 */
const PipedriveLogoBubbleComponent = ({ message }) => <OverlayTrigger
    placement="top"
    overlay={<Tooltip>{"Présent sur Pipedrive" + (message ? " - " + message : "")}</Tooltip>}
    >
    <div className="bubbleLogoPipedrive">
        <span></span>
    </div>
</OverlayTrigger>;

PipedriveLogoBubbleComponent.propTypes = {
    message: PropTypes.string,
};

export default PipedriveLogoBubbleComponent;
